import { gql } from "@stadium/services/apollo-client";

import {
  WORKSPACE_DETAILS,
  WORKSPACE_META_DETAILS,
  TEAM_DETAILS,
} from "@stadium/hooks/graphql/fragments/workspace";
import { CONTACT_PROVIDER_DETAILS } from "@stadium/hooks/graphql/fragments/contacts/contact-provider";

export const fetchWorkspaces = gql`
  query Workspaces($type: String = "") @api(name: "users") {
    workspaces(type: $type) {
      id
      name
      number
      type
      iconUrl
      slug
      usersCount
      isDefault
    }
  }
`;

export const fetchWorkspaceBySlug = gql`
  query fetchWorkspaceBySlug(
    $slug: String!
    $includeMetaDetails: Boolean = false
    $includeUserDetails: Boolean = false
    $includeWorkspaceDetails: Boolean = true
  ) @api(name: "users") {
    workspace(slug: $slug) @include(if: $includeWorkspaceDetails) {
      ...WorkspaceDetails
      package {
        intent
        id
        name
        packageDetail {
          iconImageUrl
          bgImageUrl
          customPricing
        }
      }
      currencyCode
      subscription {
        id
        daysLeft
        status
      }
      company {
        id
        number
      }
      ownerUsers {
        id
        fullName
        email
      }
      workspaceMetadata @include(if: $includeMetaDetails) {
        ...WorkspaceMetaDetails
      }
      adminsCount
      sendersCount
      membersCount
      nonMembersCount
    }
    currentWorkspaceUser(slug: $slug) @include(if: $includeUserDetails) {
      id
      permissions
      roles: displayRoles
      workspacePoints
      pendingWorkspacePoints
      kudosProgramPresent
      active
      user {
        accountIds
      }
      contactFilters
      contactProviders {
        ...ContactProviderDetails
      }
      teams {
        ...TeamDetails
      }
    }
  }
  ${WORKSPACE_DETAILS}
  ${WORKSPACE_META_DETAILS}
  ${TEAM_DETAILS}
  ${CONTACT_PROVIDER_DETAILS}
`;

export const fetchWorkspaceUserCount = gql`
  query fetchWorkspaceUserCount($slug: String!) @api(name: "users") {
    workspace(slug: $slug) {
      id
      adminsCount
      sendersCount
      membersCount
    }
  }
`;

export const fetchWorkspaceTeamWallet = gql`
  query fetchWorkspaceTeamWallet($slug: String!) @api(name: "users") {
    currentWorkspaceUser(slug: $slug) {
      id
      teams {
        id
        myWalletBalance
        unallocatedWalletBalance
        totalWalletBalance
      }
    }
  }
`;

export const fetchWorkspacePoints = gql`
  query fetchWorkspacePoints($slug: String!) @api(name: "users") {
    workspace(slug: $slug) {
      id
      unallocatedPoints
    }
    currentWorkspaceUser(slug: $slug) {
      id
      workspacePoints
      pendingWorkspacePoints
    }
  }
`;
